import React from "react";
import { useAuth } from "../contexts/AuthProvider";

const ScoreCard = ({
  correctSentences,
  correctWords,
  timeTaken,
  timeRemining,
  handleRestart,
}) => {
  const { user } = useAuth();
  return (
    <div className="max-w-sm mx-auto bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-200">
      <div className="bg-blue-500 text-white text-xl font-semibold p-4 text-center">
        Scorecard <br />
      </div>

      <div className="p-6 text-gray-700">
        <div className="space-y-4">
          <div className="flex">
            <div className="w-[70%] font-bold ">
              சரியாக அடுக்கப்பட்ட குறள்கள்:
            </div>
            <div className="w-[30%] text-right font-bold font-mono text-2xl">
              {correctSentences}
            </div>
          </div>

          <div className="flex">
            <div className="w-[70%] font-bold">
              சரியாக அடுக்கப்பட்ட சீர்கள்:
            </div>
            <div className="w-[30%] text-right font-bold font-mono text-2xl">
              {correctWords}
            </div>
          </div>

          <div className="flex">
            <div className="w-[70%] font-bold">எடுத்துக்கொண்ட நேரம்:</div>
            <div className="w-[30%] text-right font-bold font-mono text-2xl">
              {timeTaken}
            </div>
          </div>

          <div className="flex">
            <div className="w-[70%] font-bold ">மீத நேரம்:</div>
            <div className="w-[30%] text-right font-bold font-mono text-2xl">
              {timeRemining}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-100 p-4 flex flex-col items-center gap-3">
        <span>Name: {user.name}</span>
        <span>Mobile: {user.mobileno}</span>
        <button
          onClick={handleRestart}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-600"
        >
          Restart the Game
        </button>

        <div className="text-gray-600 font-medium">
          {new Date().toLocaleString("ta-IN", {
            dateStyle: "full",
            timeStyle: "medium",
          })}
        </div>
      </div>
    </div>
  );
};

export default ScoreCard;
